import React from 'react';

import Icon, {Icons} from '@pb/kit-component-icon';
import {ListBoxItem} from '@pb/kit-component-listbox';
import {MenuItemCaption, MenuItemMeta} from '@pb/kit-component-menu';
import {withCssModule} from '@pb/kit-util-with-css-module';

import comboBoxStyles from './combo-box.component.module.styl';

import type {ListBoxItemProps} from '@pb/kit-component-listbox';


const classNames = withCssModule(comboBoxStyles);

type _ListBoxItemProps = Omit<ListBoxItemProps, 'caption' | 'value'>;

export interface ComboboxItemProps<ItemValue> extends _ListBoxItemProps {
    /**
     * This caption will be displayed for item, can be string only cause it is used in Input as a value
     */
    caption: string,

    /**
     * Do not use this prop. It is passed with Children.map
     * */
    dropdown?: boolean,

    /**
     * Value covered by this item
     */
    value: ItemValue,
}


/**
 * @see [Storybook]{@link https://storybook.dev.pitchbookdata.com/?path=/docs/forms-combo-box}
 * */
function ComboboxItem<ItemValue>({
    dropdown,
    caption,
    meta,
    children,
    // to filter restProps, used in Combobox via Children.map
    value,
    ...props
}: ComboboxItemProps<ItemValue>) {
    return (
        <ListBoxItem {...props}>
            {children ?? (
                <>
                    <MenuItemCaption>
                        {caption}
                    </MenuItemCaption>
                    {meta ? (
                        <MenuItemMeta>
                            {meta}
                        </MenuItemMeta>
                    ) : null}
                    {!dropdown ? (
                        <Icon
                            type={Icons.CHECK}
                            className={classNames('item__check', {selected: props.selected})}
                        />
                    ) : null}
                </>
            )}
        </ListBoxItem>
    );
}

ComboboxItem.displayName = 'ComboboxItem';

export {ComboboxItem};
